import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-studies/CaseStudiesPage.tsx");
